import { SectorsServiceInterface } from 'domain/services';
import {
  GetAllSectorsUseCaseInterface,
  CreateSectorUseCaseInterface,
  GetSectorByIdUseCaseInterface,
  UpdateSectorUseCaseInterface,
  DeleteSectorUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  getAllSectors: GetAllSectorsUseCaseInterface;
  getSectorById: GetSectorByIdUseCaseInterface;
  createSector: CreateSectorUseCaseInterface;
  updateSector: UpdateSectorUseCaseInterface;
  deleteSector: DeleteSectorUseCaseInterface;
}

export class SectorsService implements SectorsServiceInterface {
  private readonly _getAllSectors: GetAllSectorsUseCaseInterface;
  private readonly _getSectorById: GetSectorByIdUseCaseInterface;
  private readonly _createSector: CreateSectorUseCaseInterface;
  private readonly _updateSector: UpdateSectorUseCaseInterface;
  private readonly _deleteSector: DeleteSectorUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllSectors = usecases.getAllSectors;
    this._getSectorById = usecases.getSectorById;
    this._createSector = usecases.createSector;
    this._updateSector = usecases.updateSector;
    this._deleteSector = usecases.deleteSector;
  }

  getAllSectors(
    params: GetAllSectorsUseCaseInterface.Params,
  ): Promise<GetAllSectorsUseCaseInterface.Result> {
    return this._getAllSectors.execute(params);
  }

  getSectorById(
    params: GetSectorByIdUseCaseInterface.Params,
  ): Promise<GetSectorByIdUseCaseInterface.Result> {
    return this._getSectorById.execute(params);
  }

  createSector(
    params: CreateSectorUseCaseInterface.Params,
  ): Promise<CreateSectorUseCaseInterface.Result> {
    return this._createSector.execute(params);
  }

  updateSector(
    params: UpdateSectorUseCaseInterface.Params,
  ): Promise<UpdateSectorUseCaseInterface.Result> {
    return this._updateSector.execute(params);
  }

  deleteSector(
    params: DeleteSectorUseCaseInterface.Params,
  ): Promise<DeleteSectorUseCaseInterface.Result> {
    return this._deleteSector.execute(params);
  }
}
